import React from "react";
import "./index.css";

// Importing components
import Navbar from "./components/Navbar";
import Profile from "./components/ProfileSection";
import Skills from "./components/Skills";
import DesignTools from "./components/DesignTools";
import Projects from "./components/Projects";
import AboutSection from "./components/AboutSection";
import Hobbies from "./components/Hobbies";
import Footer from "./components/Footer";

function App() {
  return (
    <main className="main-app">
      <section className="hero-section">
        <Navbar />
        <Profile />
      </section>
      <div>
        <Skills />
        <DesignTools />
        <Projects />
        <AboutSection />
        <Hobbies />
        <Footer />
      </div>
    </main>
  );
}

export default App;
